import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { Building, Service, ServiceBooking } from '../../models';
import { ApiService } from '../../utils/api.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class ServiceBookingService {

  path = 'service_bookings';
  constructor(
    private apiService: ApiService,
  ) {
  }

  /**
   * Return the addition of all serviceBookings quantity for the given service
   *
   * @param serviceBookings List of service bookings to count in
   * @param service Service to count in particular in the list of service bookings
   * @return
   */
  countAssociateServiceBookings(serviceBookings: ServiceBooking[], service: Service): number {
    if (serviceBookings) {
      const selection = serviceBookings
        .filter(serviceBooking => serviceBooking.service === service['@id']);
      return selection.reduce(
        (accumulator, currentValue) => accumulator + currentValue.quantity,
        0,
      );
    } else {
      return 0;
    }
  }

  getAll(params: HttpParams = new HttpParams()): Observable<ServiceBooking[]> {
    return this.apiService.get(`${this.path}`, params);
  }

  getAllBetweenDates(startDate: Date, endDate: Date, services: Service[] = []): Observable<ServiceBooking[]> {
    let params = new HttpParams();
    params = params.set('date[after]', startDate.toDateString());
    params = params.set('date[before]', endDate.toDateString());
    params = params.set('pagination', 'false');

    if (services.length > 0) {
      services.forEach(service => {
        params = params.append('service[]', encodeURI(service['@id']));
      });
    }

    return this.apiService.get(this.path, params);
  }

  /**
   * @param serviceBookings
   * @param service
   * @return
   */
  getFillingPurcentage(serviceBookings: ServiceBooking[], service: Service): number {
    return (+this.countAssociateServiceBookings(serviceBookings, service) / +service.quantityLimitAdmin) * 100;
  }

  getForServiceByDate(service: Service, date: Date): Observable<ServiceBooking> {
    let params = new HttpParams();
    params = params.set('date[before]', date.toDateString());
    params = params.set('date[after]', date.toDateString());

    const building: Building | string = service.building;
    let buildingUri: string;
    if (building instanceof Building) {
      buildingUri = 'buildings/' + building.id;
    } else {
      buildingUri = building.replace('\/api\/', '');
    }
    const path = `${buildingUri}/services/${service.id}/${this.path}`;

    return this.apiService.get(path, params);
  }
}
